import React, { useEffect, useState } from "react";
import SalesSummaryChart from "../../components/SalesSummaryChart";
import { useMutation } from "@tanstack/react-query";
import SupervisorApi from "../../utility/supervisorApi";
import SelectLabels from "../../components/SelectLabels";

function StorePerformance() {
  const { createData } = SupervisorApi();
  const [timeRange, setTimeRange] = useState(0);
  const [newPeriod, setNewPeriod] = useState("7days");
  const [dataset, setDataset] = useState(null); // Store the chart data

  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  const defaultNum = 0;

  // Change the selected period and update the period key
  // useEffect(() => {
  //   setNewPeriod(period[timeRange].key);
  // }, [timeRange]);

  useEffect(() => {
    const selected = period[timeRange];
    if (selected) {
      setNewPeriod(selected.key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange]);

  const chartData = useMutation({
    mutationFn: (newPeriod) =>
      createData(
        `dashboard/performance-overview?date_filter=${newPeriod}`,
        null,
        true
      ),
  });

  // Handle select dropdown change
  const handleChange = (value) => {
    setTimeRange(value);
  };

  // Fetch the data when newPeriod changes
  useEffect(() => {
    chartData.mutate(newPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPeriod]);

  // Transform the fetched data into the correct chart format when data is available
  useEffect(() => {
    if (chartData?.data) {
      const labels = chartData?.data?.data.map((store) => store.label) || []; // Labels will be store names
      const datasets = [
        {
          label: "Revenue", // This label will be for the entire dataset
          data: chartData?.data?.data.map((store) => store.data) || [], // All store sales data in one array
          backgroundColor:
            chartData?.data?.data.map((store) => store.color) || [], // Store colors
          borderColor: chartData?.data?.data.map((store) => store.color) || [], // Optional: Border color
          borderWidth: 1,
        },
      ];

      // Create the chart data
      const newChartData = {
        labels: labels, // X-axis labels will be the store names
        datasets: datasets, // All sales data will be in one dataset
      };

      setDataset(newChartData); // Update the dataset state
    }
  }, [chartData.data]); // Trigger when the chart data changes

  return (
    <div className="mb-6">
      <div className="flex justify-between">
        <h3 className="text-3xl font-semibold mb-2">
          Store Performance Overview
        </h3>
        <div>
          <SelectLabels
            valueKey="id"
            labelKey="time"
            text="Select a period"
            categoryData={period}
            onSelectChange={handleChange}
            previousValue={defaultNum}
          />
        </div>
      </div>

      {/* Conditionally render the chart if the dataset is available */}
      {dataset && (
        <SalesSummaryChart dataset={dataset} datasets={dataset.datasets} />
      )}
    </div>
  );
}

export default StorePerformance;
